import { ref, update } from "firebase/database";
import { storage, db } from "./firebase";
import { v4 as uuidv4 } from "uuid";
import {
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";
import bcrypt from "bcryptjs";
import { setAuthorization } from "../Functions/AuthFunction";
import { verifyAuth } from "./authFunction";


export const getCompanyDetails = async () => {
  try {
    const response = await verifyAuth();
    if (!response.success) {
      return {
        success: false,
        error: "Unauthorized: Invalid Administrative Token.",
      };
    }
    const { adminData } = response;
    if (!adminData) {
      return { success: false, error: "Administrative record not found." };
    }
    const sendData = {
      adminId: adminData.adminId,
      name: adminData.name,
      email: adminData.email,
      mobile: adminData.mobile,
      role: adminData.role || "Chief Administrator",
      profilePicURL: adminData.profilePicURL,
      status: adminData.status,
      subscription: adminData.subscription,
      lastLoginAt: adminData.lastLoginAt,
      companyName: adminData.companyName,
      websiteUrl: adminData.websiteUrl,
      joinedDate: adminData.startDate || adminData.createdAt,
    };
    return { success: true, data: sendData };
  } catch (error) {
    console.error("🔥 Error fetching administrative details:", error);
    return {
      success: false,
      message: error.message || "Failed to retrieve administrative details.",
    };
  }
};
export const updateAdminProfilePicture = async (file) => {
  const ADMINS_PATH = "contacthq/admins"; //

  if (!file)
    return {
      success: false,
      message: "No file uploaded. Please select a valid image file.",
    };

  if (file.size > 2 * 1024 * 1024)
    return { success: false, message: "File size must be under 2MB." };

  try {
    // Verify current administrative session
    const auth = await verifyAuth();
    if (!auth.success) return { success: false, error: auth.error };

    const { adminId } = auth.adminData;

    // Define administrative storage reference
    const picStorageRef = storageRef(
      storage,
      `${ADMINS_PATH}/${adminId}/profile`,
    );

    // Upload and retrieve public URL
    await uploadBytes(picStorageRef, file);
    const profilePicURL = await getDownloadURL(picStorageRef);

    // Synchronize administrative node
    await update(ref(db, `${ADMINS_PATH}/${adminId}`), { profilePicURL });

    return {
      success: true,
      message: "Administrative profile picture updated successfully.",
      profilePicURL,
    };
  } catch (error) {
    console.error("🔥 Admin Profile picture update error:", error);
    return {
      success: false,
      message: error.message || "An error occurred during provisioning.",
    };
  }
};
export const changeAdminPassword = async (oldPassword, newPassword) => {
  const ADMINS_PATH = "contacthq/admins"; //

  try {
    // Verify administrative session and retrieve master key hash
    const auth = await verifyAuth();
    if (!auth.success)
      return { success: false, error: "Unauthorized: Invalid Administrative Session." };

    const { adminId, password: currentHashedPassword } = auth.adminData;

    // Validate existing Master Access Key
    const isMatch = bcrypt.compareSync(oldPassword, currentHashedPassword);
    if (!isMatch) return { success: false, error: "Incorrect current Master Access Key." };

    // Secure new credential and generate fresh session token
    const hashedNewPassword = bcrypt.hashSync(newPassword, 10);
    const newToken = uuidv4();
    const timestamp = new Date().toISOString();

    const adminRef = ref(db, `${ADMINS_PATH}/${adminId}`);

    // Update administrative security node
    await update(adminRef, {
      token: newToken,
      password: hashedNewPassword,
      lastPasswordChange: timestamp,
    });

    // Synchronize local administrative authorization
    setAuthorization(newToken, adminId);

    return { success: true, message: "Master Access Key updated successfully." };
  } catch (error) {
    console.error("Change Admin Key Error:", error);
    return { success: false, error: "An unexpected administrative service error occurred." };
  }
};